import { AnyAction } from 'redux'

export { default as actions } from './actions'

export enum MicroSurveyTypes {
  UPDATE_MICROSURVEY_UNFOLLOW_TAGS = 'UPDATE_MICROSURVEY_UNFOLLOW_TAGS',
  NONE = '',
}
export interface MicroSurveyTag {
  Id: string
  Icon: string
  Name: string
}
export interface MicroSurveyState {
  unfollowTags?: MicroSurveyTag[]
}

const INITIAL_STATE: MicroSurveyState = {
  unfollowTags: [],
}

const microsurvey = (
  state = INITIAL_STATE,
  action: AnyAction = {
    type: MicroSurveyTypes.NONE,
    payload: [],
  },
) => {
  switch (action.type) {
    case MicroSurveyTypes.UPDATE_MICROSURVEY_UNFOLLOW_TAGS:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

export default microsurvey
